import { createVanIconComponent } from "./van"

const Award = createVanIconComponent("award")
export default Award
